import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import Multiselect from 'vue-multiselect'
export default {
	name: 'hub-machine-configuration-details',
	components: {
		BasicSelect,
		VueElementLoading,
		Multiselect
	},
	props: [],
	data() {
		return {
			modalShow: false,
			hubzonelist: [],
			hubzoneitem: {
				id: '',
				text: ''
			},
			hubnamelist: [],
			hubnameitem: {
				id: '',
				text: ''
			},
			hubzone: '',
			hubname: '',
			machinenumber: '',
			machinetype: '',
			url: '',
			hubzoneLoading: '',
			hubLoading: '',
			//for search filter
			MachineConfigurationDetails: [],
			flthubnamelist: [],
			flthubnameitem: {
				id: '',
				text: ''
			},
			flthubzoneitem: {
				id: '',
				text: ''
			},
			flthubzone: '',
			flthubname: '',
			isLoading: false,
			fltmachinetype: '',
			flthubnameLoading: '',
			hubmachineconfigurationdetailsid: '',
			isEditMode: false,
			disabledMachineNumber: 0,
			disabledMachineType: 0,
			Machineaction: 'add',
			hubzoneError: '',
			hubnameError: '',
			machinetypeError: ''
		}
	},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.warehouseid = userdetail[0].warehouseid;
		this.createdBy = userdetail[0].email;
		this.getHubZone();
	},
	methods: {
		selectHubZone(hubzoneitem) {
			this.hubzoneitem = hubzoneitem
			this.hubzone = this.hubzoneitem.text
			this.hubname=''
			if (this.hubzone != undefined) {
				this.getHubName()
			}
			this.hubnamelist = []
			this.hubnameitem = {
				id: '',
				text: ''
			}
		},
		selectHubName(hubnameitem) {
			this.hubnameitem = hubnameitem
			this.hubname = this.hubnameitem.text
		},
		SearchHubZoneName(flthubzoneitem) {
			this.flthubzoneitem = flthubzoneitem
			this.flthubzone = this.flthubzoneitem.text
			if (this.flthubzone != undefined) {
				this.getHubNameforFilter()
			}
			this.flthubnamelist = []
			this.flthubnameitem = {
				id: '',
				text: ''
			}
			if (this.flthubzone == '' || this.flthubzone == undefined) {
				this.hubzoneError = 'The Hub Zone Name field is required.';
			} else {
				this.hubzoneError = '';
			}
		},
		SearchHubName(flthubnameitem) {
			this.flthubnameitem = flthubnameitem
			this.flthubname = this.flthubnameitem.text
			if (this.flthubname == '' || this.flthubname == undefined) {
				this.hubnameError = 'The Hub Name field is required.';
			} else {
				this.hubnameError = '';
			}
		},
		SearchMachineType() {
			if (this.fltmachinetype == '') {
				this.machinetypeError = 'The Machine Type field is required.';
			} else {
				this.machinetypeError = '';
			}
		},
		//to get hubzone list
		getHubZone() {
			this.hubzoneLoading = 'Loading Hub Zone...'
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubzoneLoading = ''
					var HubZoneListData = result.data.ResponseData;
					for (i = 0; i < HubZoneListData.length; i++) {
						this.hubzonelist.push({
							id: HubZoneListData[i].hubzoneid,
							text: HubZoneListData[i].hubzonename
						})
					}
				}, error => {
					console.error(error)
				})
		},
		//to get hubname list
		getHubName() {
			this.hubLoading = 'Loading Hub...'
			var i = 0;
			var self = this
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: this.hubzoneitem.id,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list/',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var HubNameData = result.data.ResponseData
					for (i = 0; i < HubNameData.length; i++) {
						this.hubnamelist.push({
							id: HubNameData[i].HubID,
							text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
						})
					}
				}, error => {
					console.error(error)
				})
		},
		//to get hubname list for search filter
		getHubNameforFilter() {
			this.flthubnameLoading = 'Loading Hub...'
			var i = 0;
			var self = this
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: this.flthubzoneitem.id,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list/',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.flthubnameLoading = ''
					var HubNameData = result.data.ResponseData
					for (i = 0; i < HubNameData.length; i++) {
						this.flthubnamelist.push({
							id: HubNameData[i].HubID,
							text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
						})
					}
				}, error => {
					console.error(error)
				})
		},
		chkFields() {
			var isErr = 0;
			if (this.flthubzone == '' || this.flthubzone == undefined) {
				this.hubzoneError = 'The Hub Zone Name field is required.';
				isErr = 1;
			} else {
				this.hubzoneError = '';
			}
			if (this.flthubname == '' || this.flthubname == undefined) {
				this.hubnameError = 'The Hub Name field is required.';
				isErr = 1;
			} else {
				this.hubnameError = '';
			}
			if (this.fltmachinetype == '') {
				this.machinetypeError = 'The Machine Type field is required.';
				isErr = 1;
			} else {
				this.machinetypeError = '';
			}
			if (isErr == 1) {
				return false;
			}
		},
		// to get machine configuration details list
		getMachineConfigurationDetailsList() {
			if (this.chkFields() == false) {
				return false;
			}
			this.MachineConfigurationDetails = []
			this.isLoading = true;
			this.input = ({});
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'fetchHubMachineConfiguration?hubId=' + this.flthubnameitem.id + '&machineType=' + this.fltmachinetype,
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.ResultCode == 100) {
						this.MachineConfigurationDetails = result.data.ResponseData;
					}
				}, error => {
					console.error(error)
				})
		},
		//add Machine configuration details
		saveMachineConfigurationDetails() {
			this.input = {
				"hubId": this.hubnameitem.id,
				"hubName": this.hubnameitem.text,
				"url": this.url,
				"machineNo": this.machinenumber,
				"machineType": this.machinetype,
				"createdBy": this.createdBy
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'allocateHubMachineConfiguration',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						//this.$alertify.success(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "success");
						this.resetForm()
					} else {
						//this.$alertify.error(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "error");
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		resetForm() {
			this.hubzoneitem = {
				id: '',
				text: ''
			}
			this.hubnameitem = {
				id: '',
				text: ''
			}
			this.hubzone = ''
			this.hubname = ''
			this.machinenumber = ''
			this.machinetype = ''
			this.url = ''
			this.isEditMode = false
			this.disabledMachineNumber = 0
			this.disabledMachineType = 0
			this.$validator.reset()
		},
		//opens active/inactive modal
		openStatusModal(data) {
			this.modaldata = data
			this.modalShow = true
		},
		//close active/inactive modal
		closeStatusModal() {
			this.modalShow = false
		},
		//for active/inactive modal
		changeStatus() {
			var newactStatus = this.modaldata.isactive ? false : true
			this.input = {
				"hubId": this.modaldata.hubid,
				"machineNo": this.modaldata.machineno,
				"machineType": this.modaldata.machinetype,
				"createdBy": this.createdBy,
				"isActive": newactStatus
			}
			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'deAllocateHubMachineConfiguration',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						//this.$alertify.success(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "success");
						this.getMachineConfigurationDetailsList()
					} else {
						this.$alert(response.data.ReturnMessage, "", "error");
						//this.$alertify.error(response.data.ReturnMessage)
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		getMachineConfigurationRowData(data) {
			this.Machineaction = 'edit'
			this.isEditMode = true
			this.disabledMachineNumber = 1
			this.disabledMachineType = 1
			window.scrollTo(500, 0);
			this.hubmachineconfigurationdetailsid = data.hubmachineconfigurationdetailsid
			this.hubnameitem.text = data.hubname
			this.hubnameitem.id = data.hubid
			this.machinenumber = data.machineno
			this.machinetype = data.machinetype
			this.url = data.url
		},
		//update Machine configuration details
		updateMachineConfigurationDetails() {
			this.input = {
				"hubMachineConfigurationDetailsId": this.hubmachineconfigurationdetailsid,
				"url": this.url
			}
			axios({
					method: 'PUT',
					url: apiUrl.api_url_hubops + 'updateHubMachineConfiguration',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						//this.$alertify.success(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "success");
						this.resetForm()
					} else {
						this.$alert(response.data.ReturnMessage, "", "error");
						//this.$alertify.error(response.data.ReturnMessage)
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.saveMachineConfigurationDetails()
				} else {
					console.log('errors exist', this.errors)
				}
			}).catch(() => {
				console.log('errors exist')
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/components/hubMachineConfiguration/hubMachineConfiguration.component.js